import ApiClient from "../helpers/ApiClient";


export const addStudentLifeData = async (formDataToSend) => {
    try {
        const response = await ApiClient.post(`/researchandstudentlife/addClubSocities`,
            formDataToSend,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getStudentLifeData = async () => {
    try {
        const response = await ApiClient.get(`/researchandstudentlife/getClubSocities`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const editStudentLifeData = async (id, formDataToSend) => {  //Receive id and FormData
    try {
        const response = await ApiClient.patch(`/researchandstudentlife/updateClubSocities/${id}`,
            formDataToSend,  //Send FormData
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response  edit", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const deleteStudentLifeData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/researchandstudentlife/deleteClubSocities/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}